import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import SubscriberPage, {
  SubscriberPageFormData
} from "@saleor/subscribers/components/SubscriberPage";
import { useSubscriptionCreateMutation } from "@saleor/subscribers/mutations";
import {
  SubscriberAddUrlQueryParams,
  subscriberListUrl,
  subscriberUrl
} from "@saleor/subscribers/urls";
import React from "react";
import { useIntl } from "react-intl";

interface SubscriberDetailsProps {
  params: SubscriberAddUrlQueryParams;
}

const SubscriberDetails: React.FC<SubscriberDetailsProps> = ({}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const [subscriberCreate, subscriberCreateOpts] = useSubscriptionCreateMutation({
    onCompleted: data => {
      if (data.subscriptionCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Successfully created subscriber"
          })
        });
        navigate(subscriberUrl(data.subscriptionCreate.subscription.id));
      }
    }
  });

  const handleSubmit = async (data: SubscriberPageFormData) => {
    const input = {
      ...data
    };
    const result = await subscriberCreate({
      variables: {
        input
      }
    });
    return result.data.subscriptionCreate?.subscription?.id || null;
  };
  return (
    <>
      <SubscriberPage
        subscriber={null}
        disabled={subscriberCreateOpts.loading}
        errors={subscriberCreateOpts.data?.subscriptionCreate.errors || []}
        onBack={() => navigate(subscriberListUrl())}
        onDelete={undefined}
        onSubmit={handleSubmit}
        saveButtonBarState={subscriberCreateOpts.status}
        title={"add"}
      ></SubscriberPage>
    </>
  );
};

export default SubscriberDetails;
